// src/pages/HomePage.jsx
import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/home/Hero';
import Services from '../components/home/Services';
import WhyChoose from '../components/home/WhyChoose';
import About from '../components/home/About';
import Testimonials from '../components/home/Testimonials';
import CTA from '../components/home/CTA';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
    return (
        <>
            <Navbar />
            <Hero />
            <Services />
            <WhyChoose />
            <About />
            <Testimonials />
            <CTA />
            <Contact />
            <Footer />
        </>
    );
};

export default HomePage;
